import {Routes} from '@angular/router';
import {MappingsComponent} from "./mappings/mappings.component";
import {LoginComponent} from "./account/login/login.component";
import {authGuard} from "./_helpers/auth.guard";
import {customersResolver} from "@app/_helpers/customers.resolver";
import {auditLogResolver} from "@app/_helpers/audit-log.resolver";
import {ediFileSummaryResolver} from "@app/_helpers/edi-file-summary.resolver";
import {LiveboardComponent} from "@app/analytics/liveboard/liveboard.component";
import {SearchComponent} from "@app/analytics/search/search.component";
import {FullAppComponent} from "@app/analytics/fullapp/full-app.component";
import {DashboardComponent} from "@app/dashboard/dashboard.component";
import {Edi852FileSummaryComponent} from "@app/processing/edi-852-file-summary/edi-852-file-summary.component";
import {Edi867FileSummaryComponent} from "@app/processing/edi-867-file-summary/edi-867-file-summary.component";
import {RequestHistoryComponent} from "@app/processing/request-history/request-history.component";
import {AuditLogComponent} from "@app/audit-log/audit-log.component";
import {ExtractsComponent} from "@app/extracts/extracts.component";
import {AwsDashboardComponent} from "@app/aws-dashboard/aws-dashboard.component";
import {ForgotPasswordComponent} from "@app/account/forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "@app/account/reset-password/reset-password.component";
import {NewPasswordRequiredComponent} from "@app/account/new-password-required/new-password-required.component";
import {AdminUsersComponent} from "@app/admin-users/admin-users.component";
import {adminUsersResolver} from "@app/_helpers/admin-users.resolver";
import {TradingPartnersComponent} from "@app/master-data/trading-partners/trading-partners.component";
import {DistributionCentersComponent} from "@app/master-data/distribution-centers/distribution-centers.component";
import {ProductGroupsComponent} from "@app/master-data/product-groups/product-groups.component";
import {MasterDataLoadsComponent} from "@app/master-data/master-data-loads/master-data-loads.component";
import {Edi997ConfigComponent} from "@app/processing/edi-997-config/edi-997-config-component";
import {edi997ConfigResolver} from "@app/_helpers/edi-997-config-resolver";
import {ExtractConfigComponent} from "@app/processing/extract-config/extract-config-component";
import {extractConfigResolver} from "@app/_helpers/extract-config-resolver";
import {UsersComponent} from "@app/users/users.component";
import {WebDataConnectionsComponent} from "@app/datasources/web-data-connections/web-data-connections.component";
import {AnnouncementsComponent} from "@app/announcements/announcements.component";
import {announcementsResolver} from "@app/_helpers/announcements.resolver";
import {FeatureFlagsComponent} from "@app/feature-flags/feature-flags.component";
import {featureFlagsResolver} from "@app/_helpers/feature-flags.resolver";
import {EdiSenderReceiversComponent} from "@app/edi-sender-receivers/edi-sender-receivers.component";
import {ediSenderReceiversResolver} from "@app/_helpers/edi-sender-receivers.resolver";

export const routes: Routes = [
    {
        path: 'account',
        children: [
            {path: 'login', component: LoginComponent},
            {path: 'forgot-password', component: ForgotPasswordComponent},
            {path: 'reset-password', component: ResetPasswordComponent},
            {path: 'new-password-required', component: NewPasswordRequiredComponent},
        ],
    },
    {
        path: 'analytics',
        children: [
            {path: 'liveboard', component: LiveboardComponent, canActivate: [authGuard]},
            {path: 'search', component: SearchComponent, canActivate: [authGuard]},
            {path: 'fullapp', component: FullAppComponent, canActivate: [authGuard]},
        ],
    },
    {
        path: 'processing',
        children: [
            {path: 'edi-852-file-summary', component: Edi852FileSummaryComponent, canActivate: [authGuard], resolve: {resolvedData: ediFileSummaryResolver}},
            {path: 'edi-867-file-summary', component: Edi867FileSummaryComponent, canActivate: [authGuard], resolve: {resolvedData: ediFileSummaryResolver}},
            {path: 'requests', component: RequestHistoryComponent, canActivate: [authGuard], resolve: {resolvedData: customersResolver}},
            {path: 'edi-997-config', component: Edi997ConfigComponent, canActivate: [authGuard], resolve: {resolvedData: edi997ConfigResolver}},
            {path: 'extract-config', component: ExtractConfigComponent, canActivate: [authGuard], resolve: {resolvedData: extractConfigResolver}},
        ]
    },

    {
        path: 'master-data',
        children: [
            {path: 'trading-partners', component: TradingPartnersComponent, canActivate: [authGuard], resolve: {resolvedData: customersResolver}},
            {path: 'distribution-centers', component: DistributionCentersComponent, canActivate: [authGuard], resolve: {resolvedData: customersResolver}},
            {path: 'product-groups', component: ProductGroupsComponent, canActivate: [authGuard], resolve: {resolvedData: customersResolver}},
            {path: 'master-data-loads', component: MasterDataLoadsComponent, canActivate: [authGuard], resolve: {resolvedData: customersResolver}},
            {path: 'edi-sender-receivers', component: EdiSenderReceiversComponent, canActivate: [authGuard], resolve: {resolvedData: ediSenderReceiversResolver}},
        ],
    },

    {path: 'admin-users', component: AdminUsersComponent, canActivate: [authGuard], resolve: {resolvedData: adminUsersResolver}},
    {path: 'audit-log', component: AuditLogComponent, canActivate: [authGuard], resolve: {resolvedData: auditLogResolver}},
    {path: 'announcements', component: AnnouncementsComponent, canActivate: [authGuard], resolve: {resolvedData: announcementsResolver}},
    {path: 'aws-dashboard', component: AwsDashboardComponent, canActivate: [authGuard]},
    {path: 'dashboard', component: DashboardComponent, canActivate: [authGuard]},
    {path: 'extracts', component: ExtractsComponent, canActivate: [authGuard], resolve: {resolvedData: customersResolver}},
    {path: 'feature-flags', component: FeatureFlagsComponent, canActivate: [authGuard], resolve: {resolvedData: featureFlagsResolver}},
    {path: 'mappings', component: MappingsComponent, canActivate: [authGuard], resolve: {resolvedData: customersResolver}},
    {path: 'users', component: UsersComponent, canActivate: [authGuard], resolve: {resolvedData: customersResolver}},
    {path: 'web-data-connections', component: WebDataConnectionsComponent, canActivate: [authGuard], resolve: {resolvedData: customersResolver}},
    {path: '**', redirectTo: '/dashboard', pathMatch: 'full'},
];
